import React from 'react';
import {
  Route,
  Routes,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";
import { useEffect } from 'react'
import { LoginCallback } from "@okta/okta-react";
import { useAuth } from "../utils/auth/useAuth";
import { isOkta, isMsal } from "../utils/auth/auth-config";
import { useDispatch } from "react-redux";
import { getUserClaims } from "../utils/auth/unified-auth";
import { FetchLandingPageAction } from "../redux/action/LandingPageAction";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Landing from "../pages/Landing/Landing";
import KpiOverview from "../pages/KPIOverview/KpiOverview";
import ProcurementAcademy from "../pages/ProcurementAcademy/ProcurementAcademy";
import NpsAdminDashboard from "../pages/NpsAdminDashboard/NpsAdminDashboard";
import CommodityLanding from "../pages/CommodityReports/CommodityLanding";
import MainLayout from "../components/Layout/Layout";
import CommodityOverview from "../pages/CommodityReports/CommodityOverview";
import RISIScreen from "../pages/CommodityReports/RISIScreen";
import AcademyLanding from "../pages/ProcurementAcademy/AcademyLanding";
import CommonAcademy from "../pages/ProcurementAcademy/CommonAcademy";
import TradeAnalyticsLanding from "../pages/TradeAnalyticsReports/TradeAnalyticsLanding";
import NewsLanding from "../pages/ProcurementNews/NewsLanding";
import NewsOverview from "../pages/ProcurementNews/NewsOverview";
import DetailNews from "../pages/ProcurementNews/DetailNews";
import { RouteProvider } from "../pages/ProcurementNews/RouteContext";
import AgroTools from "../pages/AgroTools/AgroTools";
import NotificationCenter from "../pages/NotificationCenter/NotificationCenter";
import AppLayout from "./AppLayout";
import PackagingOverview from "../pages/CommodityReports/PackagingOverview";
import PackagingLanding from "../pages/CommodityReports/PackagingLanding";
import SBACCIScreen from "../pages/CommodityReports/SBACCIScreen";
import CategoryForums from "../pages/CategoryForums/CategoryForums";
import SectorSites from "../pages/SectorSites/SectorSites";
import TaxonomyScreen from "../pages/TaxonomyScreen/TaxonomyScreen";
import AIAssistant from "../pages/AIAssistant/AIAssistant";
import MarketIntelligenceChat from "../pages/AIAssistant/MarketIntelligenceChat";
import MIConversations from "../pages/AIAssistant/MIConversations";
import KnowledgeManagementChat from "../pages/AIAssistant/KnowledgeManagementChat";
import KMConversations from "../pages/AIAssistant/KMConversations";
import SpendAnalyticsAgent from "../pages/AIAssistant/SpendAnalyticsAgent";
import SpendAnalyticsConversations from "../pages/AIAssistant/SpendAnalyticsConversations";
import { SpendAnalyticsSessionProvider } from "../pages/AIAssistant/SpendAnalyticsSessionContext";
import { MISessionProvider } from "../pages/AIAssistant/MISessionContext";
import { KMSessionProvider } from "../pages/AIAssistant/KMSessionContext";

const OktaLoader = () => {
  const navigate = useNavigate();
  const [timeoutOccurred, setTimeoutOccurred] = useState(false);
  const [notAllowed, setNotAllowed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (localStorage.getItem("ph-allowed") == "not-allowed") {
        setNotAllowed(true);
        // alert("not allowed");
        // navigate("/error")
        // return <div><h5>User is not assigned to the application.</h5></div>;
      } else {
        console.log("Login Timeout triggered");
        navigate("/home");
        setTimeoutOccurred(true);
      }
    }, 3000); // 3 seconds timeout

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    return () => {
      // alert("HERE22");
      localStorage.removeItem("ph-allowed");
    };
  }, []);

  if (notAllowed) {
    return (
      <div>
        <h3>User is not assigned to the application.</h3>
      </div>
    );
  }

  return (
    <>
      <div>
        <h3>Please wait while we log you in...</h3>
      </div>
    </>
  );
};

const EnhancedLoginCallback = () => {
  const [authErrorOccured, setAuthErrorOccured] = useState(false);
  useEffect(() => {
    return () => {
      // alert("HERE33");
      localStorage.removeItem("ph-allowed");
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem("ph-allowed");
  }, []);

  return (
    <LoginCallback
      loadingElement={OktaLoader()}
      errorComponent={({ error }) => {
        // alert(error);
        localStorage.setItem("ph-allowed", "not-allowed");
        setAuthErrorOccured(true);
        return <div><h3>User is not assigned to the application.</h3></div>;
      }}
    />
  );
};
const Routers = () => {
  const { authState, authInstance, isAuthenticated } = useAuth();
  const [msalInitialized, setMsalInitialized] = React.useState(false);
  const [showWebsiteFooter, setShowWebsiteFooter] = useState(true);
  const dispatch = useDispatch();

  // Fetch user info and trigger landing page API globally, regardless of which route user lands on
  useEffect(() => {
    if (!isAuthenticated) return;
    async function fetchUserInfo() {
      const user = await getUserClaims();
      if (!user) return;
      localStorage.setItem('userInfoEmailID', btoa(JSON.stringify(user?.useremail || user?.email)));
      dispatch(FetchLandingPageAction(user));
    }
    fetchUserInfo();
  }, [isAuthenticated, dispatch]);
  const oktaLoader = () => (
    <div>
      <h3>Please wait while we log you in..</h3>
    </div>
  );

  // Handle MSAL redirect callback first
  useEffect(() => {
    if (isMsal() && authInstance && !msalInitialized) {
      console.log("MSAL: Handling redirect promise...");
      authInstance.handleRedirectPromise()
        .then((response) => {
          if (response) {
            console.log("MSAL: Login successful", response);
          }
          setMsalInitialized(true);
        })
        .catch(error => {
          console.error("MSAL redirect handling failed:", error);
          setMsalInitialized(true);
        });
    } else if (!isMsal()) {
      setMsalInitialized(true);
    }
  }, [authInstance, msalInitialized]);
  
  // Handle MSAL authentication - redirect to login if not authenticated
  useEffect(() => {
    if (isMsal() && authInstance && msalInitialized && !isAuthenticated) {
      console.log("MSAL: User not authenticated, redirecting to login...");
      authInstance.loginRedirect({
        scopes: [window.MSAL_SCOPES]
      }).catch(error => {
        console.error("MSAL login redirect failed:", error);
      });
    }
  }, [authInstance, isAuthenticated, msalInitialized]);
  
  // Store access token for API calls
  useEffect(() => {
    const storeToken = async () => {
      if (isOkta() && authState?.accessToken?.accessToken) {
        const tokenData = authState.accessToken.accessToken;
        console.log("Okta tokenData", tokenData);
        localStorage.setItem("access_token", tokenData);
      } else if (isMsal() && authState?.isAuthenticated) {
        try {
          const { getAccessToken } = await import('../utils/msal/msal-auth');
          const token = await getAccessToken();
          if (token) {
            console.log("MSAL token acquired");
            localStorage.setItem("access_token", token);
          }
        } catch (error) {
          console.error("Failed to get MSAL token:", error);
        }
      }
    };
    storeToken();
  }, [authState]);

  const getShowFooter = (data) => {
    setShowWebsiteFooter(!data);
  };

  // Show loader while MSAL is processing redirect (before handleRedirectPromise resolves)
  if (isMsal() && !msalInitialized) {
    return <div><h3>Please wait while we log you in...</h3></div>;
  }
  
  return (
    // <Router>
    //   <RouteProvider>
    //     <AppLayout>
    //       <Routes>
    //         {/* <Route
    //           path="/login"
    //           element={
    //             <LoginCallback
    //               loadingElement={oktaLoader()}
    //               errorComponent={({ error }) => {
    //                 console.error(error);
    //                 oktaLoader();
    //               }}
    //             />
    //           }
    //         /> */}
    //         <Route path="/login" element={<EnhancedLoginCallback />} />
    //         <Route path="/logout" element={<Landing />} />
    //         <Route path="/" element={<Navigate to="/home" />} />
    //         <Route path="/home" element={<Landing />} />
    //         <Route path="/procurementacademy" element={<AcademyLanding />}>
    //           <Route index element={<ProcurementAcademy />} />
    //           <Route path=":pageId" element={<CommonAcademy />}/>
    //           {/* <Route path="packaging-university" element={<PackagingUniversity />}/>
    //           <Route path="advanced-procurement" element={<AdvancedProcurement />}/>
    //           <Route path="onboarding" element={<OnboardingAcademy />}/>
    //           <Route path="digital-training" element={<DigitalTraining />}/> */}
    //         </Route>
    //         <Route path="/agroapplications" element={<AgroTools />} />
    //         <Route path="/nps-admin" element={<NpsAdminDashboard />} />
    //         <Route path="/overview" element={<MainLayout />}>
    //           <Route index element={<KpiOverview />} />
    //           <Route path="commodity" element={<CommodityLanding />}>
    //             <Route index element={<CommodityOverview />} />
    //             <Route path="risi-page" element={<RISIScreen />}/>
    //           </Route>
    //           <Route path="trade-analytics" element={<TradeAnalyticsLanding />} />
    //           <Route path="news" element={<NewsLanding />}>
    //             <Route index element={<NewsOverview />} />
    //             <Route path="news-detail/:id" element={<DetailNews />} />
    //           </Route>
    //         </Route>
    //       </Routes>
    //   </AppLayout>
    //   </RouteProvider>
    // </Router>

    <Router>
      <RouteProvider>
        <Routes>
          {/* Public Route (No Sidebar) */}
          <Route path="/login" element={isMsal() ? <Navigate to="/home" /> : <EnhancedLoginCallback />} />

          {/* Layout Route (Sidebar Persistent) */}
          <Route element={<AppLayout showWebsiteFooter={showWebsiteFooter} />}>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route
              path="/home"
              element={<Landing isShowFooter={getShowFooter} />}
            />
            <Route
              path="/logout"
              element={<Landing isShowFooter={getShowFooter} />}
            />

            <Route path="/procurement-capabilities" element={<AcademyLanding />}>
              <Route index element={<ProcurementAcademy />} />
              <Route path="*" element={<CommonAcademy />} />
            </Route>

            <Route path="/taxonomy" element={<TaxonomyScreen />} />

            <Route path="/agroapplications" element={<AgroTools />} />
            <Route path="/nps-admin" element={<NpsAdminDashboard />} />

            <Route path="/overview" element={<MainLayout />}>
              <Route
                index
                element={<KpiOverview isShowFooter={getShowFooter} />}
              />
              {/* <Route path="commodity" element={<CommodityLanding />}>
                <Route index element={<CommodityOverview />} />
                <Route path="packaging-indices" element={<PackagingLanding />}>
                  <Route index element={<PackagingOverview />} />
                  <Route path="risi-page" element={<RISIScreen />} />
                  <Route path="sba-cci" element={<SBACCIScreen />} />
                </Route>
              </Route> */}

              <Route path="mi" element={<CommodityLanding />}>
                <Route index element={<CommodityOverview />} />
                <Route path=":category" element={<PackagingLanding />}>
                  <Route index element={<PackagingOverview />} />
                  {/* RISI is now available as the "FASTMARKETS (RISI)" source inside SBACCIScreen, so
                      "corrugated" is handled by the ":subcategory" catch-all below like every other
                      MI subcategory. RISIScreen.js is left in place (unrouted) in case it's still needed. */}
                  <Route path="pet-resin" element={<SBACCIScreen />} />
                  <Route path=":subcategory" element={<SBACCIScreen />} />
                </Route>
              </Route>


              <Route
                path="trade-analytics"
                element={<TradeAnalyticsLanding />}
              />
              <Route path="news" element={<NewsLanding />}>
                <Route index element={<NewsOverview />} />
                <Route path="news-detail/:id" element={<DetailNews />} />
              </Route>
            </Route>
            <Route path="/notification-center" element={<AcademyLanding />}>
              <Route index element={<NotificationCenter />} />
            </Route>
            <Route path="/category-forums" element={<CategoryForums />} />
            <Route path="/global-sector-links" element={<SectorSites />} />
            <Route path="/ai-assistant" element={<AIAssistant />} />
            <Route
              path="/ai-assistant/market-intelligence"
              element={
                <MISessionProvider>
                  <MarketIntelligenceChat />
                </MISessionProvider>
              }
            />
            <Route
              path="/ai-assistant/market-intelligence-conversations"
              element={
                <MISessionProvider>
                  <MIConversations />
                </MISessionProvider>
              }
            />
            <Route
              path="/ai-assistant/knowledge-management"
              element={
                <KMSessionProvider>
                  <KnowledgeManagementChat />
                </KMSessionProvider>
              }
            />
            <Route
              path="/ai-assistant/knowledge-management-conversations"
              element={
                <KMSessionProvider>
                  <KMConversations />
                </KMSessionProvider>
              }
            />
            <Route
              path="/spend-analytics-ai-agent"
              element={
                <SpendAnalyticsSessionProvider>
                  <SpendAnalyticsAgent />
                </SpendAnalyticsSessionProvider>
              }
            />
            <Route
              path="/spend-analytics-ai-agent-conversations"
              element={
                <SpendAnalyticsSessionProvider>
                  <SpendAnalyticsConversations />
                </SpendAnalyticsSessionProvider>
              }
            />
          </Route>
        </Routes>
      </RouteProvider>
    </Router>
  );
};

export default Routers;
